jQuery(document).ready(function() {  
  //when back from browser back button
  if(performance.navigation.type == 2)
  {
    $('body').hide();
    window.location.href=window.location.href;
  }
  
  //left eye select changes
  $('select#lefteye').on('change', function() {
    //$('#prescription-next').addClass('btn--disable');
    $('#confirmCheckout').attr('checked', false);
    $(".checkout-confirmation .inner").removeClass('active');
    $('#btnCheckout').removeClass('btn--tertiary-accent').addClass('btn--disabled-accent');
    var leftImg = $(this).find(':selected').data('img');
    $("#leftMeter").find("#selectedLens img").attr('src', leftImg);
    var leftLens = $(this);
    var power = leftLens.find(":selected").text();
    var val = leftLens.find(":selected").val();
    $('#lefteyeval').val(val);
    
    var variantid = 'left:'+$('#lefteye').find(':selected').data('subs-variant-id')+'|right:'+$('#righteye').find(':selected').data('subs-variant-id');
    $('#variantid').val(variantid);
    
    if(val == 0) {
     $('#activeDataValue').text("0.00");
     $('#leftLensResult').text('--');
      $('#leftMeter .outofstock-div').removeClass('active');
    } else {
      $('#activeDataValue').text(power);
      $('#leftLensResult').text(power);
      
    }
    if (leftLens.find(':selected').data('variant-id') === '') {
      $('#left-lens-img').removeClass("notempty");
      $('#left-lens-img').addClass("empty");
      $('#left-lens-error').html('Please select a left lens');
    } else if (leftLens.find(':selected').data('variant-inventory') <= 0) {
      $('#leftLensResult1').text(power);
      $('#leftMeter .outofstock-div').addClass('active');
      $('#btnCheckout').removeClass('btn--tertiary-accent').addClass('btn--disabled-accent');
    } else {
      $('#leftMeter .outofstock-div').removeClass('active');
    }
    if(power > 0){
        $('#left-sight').text('Long-sighted');
    } else if (power < 0){
        $('#left-sight').text('Short-sighted');
    } else if(val == 0){
        $('#left-sight').text('');
    } 
  });
  
  //right eye select changes
  $('select#righteye').on('change', function() {
    //$('#prescription-next').addClass('btn--disable');
    $('#confirmCheckout').attr('checked', false);
    $(".checkout-confirmation .inner").removeClass('active');
    $('#btnCheckout').removeClass('btn--tertiary-accent').addClass('btn--disabled-accent');
    var rightImg = $(this).find(':selected').data('img');
     $("#rightMeter").find("#selectedLensRight img").attr('src', rightImg);
    var rightLens = $(this);
    var power = rightLens.find(":selected").text();
    var val = rightLens.find(":selected").val();
    $('#righteyeval').val(val);
        
    var variantid = 'left:'+$('#lefteye').find(':selected').data('subs-variant-id')+'|right:'+$('#righteye').find(':selected').data('subs-variant-id');
    $('#variantid').val(variantid);
    
    if(val == 0) {
     $('#activeDataValueRight').text("0.00");
     $('#rightLensResult').text('--');
      $('#rightMeter .outofstock-div').removeClass('active');
    } else {
      $('#activeDataValueRight').text(power);
      $('#rightLensResult').text(power);
    }
    if (rightLens.find(':selected').data('variant-id') === '') {
      $('#right-lens-img').removeClass("notempty");
      $('#right-lens-img').addClass("empty");
      $('#right-lens-error').html('Please select a right lens');
    } else if (rightLens.find(':selected').data('variant-inventory') <= 0) {
      $('#rightLensResult1').text(power);
      $('#rightMeter .outofstock-div').addClass('active');
      $('#btnCheckout').removeClass('btn--tertiary-accent').addClass('btn--disabled-accent');
    } else {
      $('#rightMeter .outofstock-div').removeClass('active');
    }
    if(power > 0){
        $('#right-sight').text('Long-sighted');
    } else if (power < 0){
        $('#right-sight').text('Short-sighted');
    } else if(val == 0){
        $('#right-sight').text('');
    } 
  });
});

jQuery(document).ready(function() {
    // Scroll To Toric Lens Accordion --------------------------
    $("#scrollToToric").on("click", function(){
        $(".accordion .item h3.title").removeClass('is-open');
        $(".accordion .item div.content").slideUp();
        $('.klaviyo-form-LtJF2q').parents('.item').find('h2.title').addClass('is-open');
        $('.klaviyo-form-LtJF2q').parents('.item').find('div.content').slideDown();
        setTimeout(function(){
            var ToricForm = $('.klaviyo-form-LtJF2q').parents('.item').find('h3.title'),
                ToricFormPosTop = ToricForm.offset().top;
            $("body, html").animate({
                scrollTop : ToricFormPosTop - 100
            },800);
            //$(".klaviyo-form-LtJF2q").find("input[type='text']").focus();
        },300); 
    });

    // Error Message for checkout button -----------------------
    $("div.checkout-confirmation div.checkout").on("click", function(e) {
        if ( $('.outofstock-div').hasClass("active")) {
        $('#btnCheckout').prev('span.error').text("Sorry, at least one of the powers you've selected is out of stock.");
      } else {
      if ($('#righteye').val() == '0' || $('#lefteye').val() == '0') {
        $('#btnCheckout').prev('span.error').text("Please confirm your prescription before proceeding ahead.");
      } else if (!$('#confirmCheckout').prop("checked")) {
        $('#btnCheckout').prev('span.error').text("Please agree to the terms and conditions above before proceeding.");
      }
      }
    });

    // Terms and Condition checkbox validation -------------------------
    $('#confirmCheckout').click(function() {
        if (!$(this).prop("checked") || $('#righteye').val() == '0' || $('#lefteye').val() == '0') {
          $('#btnCheckout').removeClass('btn--tertiary-accent').addClass('btn--disabled-accent');
          $(this).parents("div.inner").removeClass('active');
        } else {
            if ( !$('.outofstock-div').hasClass("active")) {
            $('#btnCheckout').prev('span.error').text('');
            $('#btnCheckout').removeClass('btn--disabled-accent').addClass('btn--tertiary-accent');
            $(this).parents("div.inner").addClass('active');
            }
        }
    });    

  
  var checkout = function(){
    //alert('checkout');
  	jQuery.ajax({
      type: "POST",
      url: '/cart/clear.js',
      dataType: 'json',
      success: function() {
        var $data = $('#fake_product').serialize();

        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: $data,
          dataType: 'json',
          success: function() {
            cookieErase('eyepowervalue');
            cookieData = {};
            cookieData['leftEye'] = jQuery("#lefteye").val();
            cookieData['rightEye'] = jQuery("#righteye").val();
            cookieCreate('eyepowervalue', JSON.stringify(cookieData), 365);
            //checkout_url = "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" + Shopify.shop + "&cart_token=" + token + "&" + ga_linker + "&" + customer_param;
            // jQuery.ajax('/account/logout').done(function() {
            //   window.location.href = '/checkout';
            // });   
            window.location.href = '/checkout';                             
          },
          error: function(err){
            console.log(err);
        	console.log('errrose');
        }
        });
      }
    });
  };
  
  $('.open-upload-popup').on('click', function(){
    $('body').addClass('open-modal');
  });
  
  // Submit prescription form --------------------------------------------
  $('#btnCheckout').on('click', function(){
    if($(this).hasClass('btn--disabled-accent')){
        return false;
    }
    
    if($(this).attr('data-action') == 'upload-prescription'){
      $('body').addClass('open-modal');
    } else {
      $(this).removeClass('btn--tertiary-accent').addClass('btn--disabled-accent');
      if($('#fileupload').length && $('#fileupload').val() != ''){
        var formData = new FormData();
        var file = $('#fileupload')[0].files[0];
        formData.append('file', file);
        formData.append('filename', $('#filename').val());
        formData.append('imgData', $('#imgData').val());
        
        $.ajax({
          url: 'https://app.dimplecontacts.com/middleware_sg/subscription/ajax/uploadprescription',
          type: 'POST',
          data: formData,
          contentType: false,
          processData: false,
          dataType: 'json',
          beforeSend: function(){
            
          },
          success: function(response){
            //console.log(response);
            if(response.status == 'success'){
              $('.uploaded-file-name').html(response.filename);          	
              $('#prescription').val(response.prescription_url);            
              checkout();
            } else {
              $('.error-msg').html(response.message);
              $('#prescription').val('');
              $('#btnCheckout').removeClass('btn--disabled-accent').addClass('btn--tertiary-accent');
            }
          }
        });
      } else {
        console.log('checkout()');
        checkout();
      }        
    }  
  });
  
  //upload file js 
  $('.upload-popup-wrap').css('opacity', 1);
  
  $('.clickupload').on('click',function(){
    if(!$(this).hasClass('clicked')){
      $('#fileupload').trigger('click');
    }
  });
  
  $('#fileupload').on('change',function(){
    if($(this).val() == ''){
      return false;
    }
    
    $('body').addClass('open-modal');
    
    var allowed_ext = ['jpg','jpeg','png'];    
    var filename = $(this).val().replace(/.*(\/|\\)/, '');
    $('#filename').val(filename);
    var file_ext = filename.substring(filename.lastIndexOf(".") + 1, filename.length);
    file_ext = file_ext.toLowerCase();
    
    if(allowed_ext.includes(file_ext)){
      var file = $('#fileupload')[0].files[0];
      var reader = new FileReader(); 
      reader.onload = function(){
        $('.preview-thumbnail img').attr('src', reader.result);
        $('#imgData').val(reader.result);
      }
      reader.readAsDataURL(file);      
            
      $('.upload-file-name').html(filename);
      $('.file-uploaded').show();
      $('#prescription-uploaded').show();            
      $('#prescription-not-uploaded').hide();
      
    } else {
      $('#fileupload').val('');
      $('.error-msg').html('Selected file type is not allowed. Please upload .jpg, .jpeg or .png files only.');
      $('.file-uploaded').hide();
      $('#prescription-uploaded').hide();
      $('#prescription-not-uploaded').show();
    }

  }); 
  
  $('#later_link').on('click', function(){
    if($(this).data('action') == 'close'){
      $('body').removeClass('open-modal');
    } else if(!$(this).hasClass('clicked')){
      $(this).addClass('clicked');
      $('#upload_link').addClass('clicked');    
      $('#confirmCheckout').prop("checked", true);
      $('#btnCheckout').attr('data-action', 'checkout');
      $('#btnCheckout').trigger('click');    
      $(this).find('img').show();
      $('.close-upload').hide();
    }
  });
  
  $('#continue-to-checkout').on('click', function(){
    if($(this).data('action') == 'close'){
      $('body').removeClass('open-modal');
    } else if(!$(this).hasClass('clicked')){
      $(this).addClass('clicked');
      $('#confirmCheckout').prop("checked", true);
      $('#btnCheckout').attr('data-action', 'checkout');
      $('#btnCheckout').trigger('click');
      $(this).find('img').show();    
      $('.close-upload').hide();
    }
  });
  
  $('.close').on('click', function(){
  	$('body').removeClass('open-modal');
    $('#prescription-uploaded').hide();
    $('#prescription-not-uploaded').show();
    if($(this).hasClass('uploaded')){
    	$('#btnCheckout').attr('data-action', 'checkout');
    }
  });  
  
  /*$('#remove-file').on('click', function(){
    $('#fileupload').val('');
  	$('.upload-file-name strong').html('');
    $('#remove-file').hide();
  });*/
  
});

//Create Cookie Function --------------------
function cookieCreate(name, value, days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
    } else {
        var expires = "";
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

//Read Cookie Function --------------------------
function cookieRead(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

//Erase Cookie Function --------------------------
function cookieErase(name) {
    cookieCreate(name, "", -1);
}